import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment";
import {DimensionType} from "./models/dimension-type.model";
import { DimensionValue } from './models/dimension-value.model';

@Injectable({
    providedIn: 'root'
})
export class DimensionTypeService {

    private apiUrl = `${environment.restApiUrl}dimension-types`;

    constructor(private http: HttpClient) { }

    /**
     * Creates a new DimensionType.
     * Corresponds to: POST /api/dimension-types
     * @param dimensionType The DimensionType object to create.
     */
    createDimensionType(dimensionType: DimensionType): Observable<DimensionType> {
        return this.http.post<DimensionType>(this.apiUrl, dimensionType);
    }

    /**
     * Retrieves a single DimensionType by its ID.
     * Corresponds to: GET /api/dimension-types/{id}
     * @param id The ID of the DimensionType to retrieve.
     */
    getDimensionTypeById(id: number): Observable<DimensionType> {
        return this.http.get<DimensionType>(`${this.apiUrl}/${id}`);
    }

    /**
     * Retrieves all DimensionTypes for a given company.
     * Corresponds to: GET /api/dimension-types/by-company/{owningCompanyId}
     * @param owningCompanyId The ID of the owning company.
     */
    getDimensionTypesByCompany(owningCompanyId: number): Observable<DimensionType[]> {
        return this.http.get<DimensionType[]>(`${this.apiUrl}/by-company/${owningCompanyId}`);
    }

    /**
     * Updates an existing DimensionType.
     * Corresponds to: PUT /api/dimension-types/{id}
     * @param id The ID of the DimensionType to update.
     * @param dimensionTypeDetails The updated DimensionType data.
     */
    updateDimensionType(id: number, dimensionTypeDetails: Partial<DimensionType>): Observable<DimensionType> {
        return this.http.put<DimensionType>(`${this.apiUrl}/${id}`, dimensionTypeDetails);
    }

    /**
     * Deletes a DimensionType by its ID.
     * Corresponds to: DELETE /api/dimension-types/{id}
     * @param id The ID of the DimensionType to delete.
     */
    deleteDimensionType(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    /**
     * Retrieves all possible values for a given dimension type by its table name.
     * @param owningCompanyId
     * @param tableName The table name defined in the DimensionType.
     */
    getValuesForDimension(owningCompanyId: number, tableName: string): Observable<DimensionValue[]> {
        // This endpoint name is an assumption but follows RESTful patterns.
        return this.http.get<DimensionValue[]>(`${this.apiUrl}/companyId/${owningCompanyId}/values/${tableName}`);
    }
}
